import { DangerPentagonIcon } from "@cynthai/icons";
import NiceModal from "@ebay/nice-modal-react";

import Button from "../Button";
import { useNiceModal } from "../hooks/useNiceModal";
import { m } from "../paraglide/messages";
import type { BaseModalProps } from "../types";
import BaseModal from "./BaseModal";

interface ValidationErrorModalProps extends BaseModalProps {
  invalidCount: number;
  onContinue?: () => void;
}

const ValidationErrorModal = NiceModal.create(
  (props: ValidationErrorModalProps) => {
    const modalProps = useNiceModal();
    const { onClose, onOpenChange, invalidCount, onContinue } = props;

    const handleContinue = () => {
      modalProps.onClose();
      onClose?.();
      onContinue?.();
    };

    return (
      <BaseModal
        isDismissable={true}
        isKeyboardDismissDisabled={false}
        title={m.validation_error_modal_title()}
        size="md"
        footer={
          <div className="flex w-full gap-3">
            <Button
              variant="bordered"
              className="flex-1"
              onPress={() => {
                modalProps.onClose();
                onClose?.();
              }}
            >
              {m.validation_error_go_back()}
            </Button>
            <Button color="primary" className="flex-1" onPress={handleContinue}>
              {m.validation_error_continue()}
            </Button>
          </div>
        }
        {...modalProps}
        onClose={() => {
          modalProps.onClose();
          onClose?.();
        }}
        onOpenChange={(open) => {
          modalProps.onOpenChange(open);
          onOpenChange?.(open);
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <div
              className={`bg-danger/10 flex size-10 items-center justify-center rounded-full`}
            >
              <DangerPentagonIcon
                className="text-danger"
                height={24}
                width={24}
              />
            </div>
            <div className="flex-1">
              <p className="text-text-secondary text-sm">
                {invalidCount === 1
                  ? m.validation_error_modal_subtitle_one()
                  : m.validation_error_modal_subtitle_other({
                      count: invalidCount,
                    })}
              </p>
            </div>
          </div>
          <p className="text-text-secondary text-sm">
            {m.validation_error_modal_description()}
          </p>
        </div>
      </BaseModal>
    );
  },
);

export default ValidationErrorModal;
